import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Project } from '@src/app/models/project';
import { Task } from '@src/app/models/task';
import { Stage } from '@src/app/models/stage';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Injectable({
  providedIn: 'root'
})
export class ProjectstageService {

  constructor(private http: HttpClient) { }

  // /project/{projectId}/task/
  addTask(task: Task) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + task.projectId + '/task/', task, httpOptions);
  }
  generateStats(projectId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<Project>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + projectId + '/stats/overview', '', httpOptions);

  }
  // /project/{projectId}/stage/{stageId}
  editStage(stage: Stage) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + stage.projectId + '/stage/' + stage.stageId, stage, httpOptions);

  }
  // /project/{projectId}/stage/{stageId}
  deleteStage(stage: Stage) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + stage.projectId + '/stage/' + stage.stageId, httpOptions);
  }
  //PUT	    /organization/{organizationId}/project/{projectId}/taskorder 
  taskOrder(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    //console.log(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+data.container[0].projectId.split('_')[0]+'/taskorder');
    return this.http.put<any>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + data.container[0].projectId.split('_')[0] + '/taskorder', JSON.stringify(data), httpOptions);

  }
}
